import { ToastProvider } from "../../../components/ToastNotification/toastProvider";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { publishModalVisibility } from "../../../redux/features/modal/modalSlice";
import Modal from "../../../components/Modal/modal";
import { useIsMobile } from "../../../redux/features/device/selectors";
import MobileLayout from "./components/mobileLayout";
import DesktopLayout from "./components/desktopLayout";
import Header from "../../../(general-header)/header/page";

const SubscriptionCompetitionsPageContent = () => {
  const isMobile = useIsMobile();

  // TODO - this modal is from houseCompetition, to be imported into our area
  const isModalOpen = useAppSelector(state => state.modal.isOpen);
  const modalData = useAppSelector(state => state.modal.data);
  const modalOverlay = useAppSelector(state => state.modal.withOverlay);
  const modalClassNames = useAppSelector(state => state.modal.modalClassNames);
  const modalStyles = useAppSelector(state => state.modal.modalStyles);
  const dispatch = useAppDispatch();

  return (
    <>
      <header id="botb-header" className="sticky top-0 bg-white z-[1003] botb-pass-header">
        <Header renderModalComponentHere={false} />
      </header>

      {isMobile ? <MobileLayout /> : <DesktopLayout />}
      <Modal
        withOverlay={modalOverlay}
        closeModal={event => {
          event.stopPropagation();
          dispatch(publishModalVisibility({ isOpen: false }));
        }}
        isOpen={isModalOpen}
        body={modalData}
        title=""
        modalClassNames={modalClassNames}
        customStyles={modalStyles}
      />

      <ToastProvider />
    </>
  );
};

export default SubscriptionCompetitionsPageContent;
